import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import style from './style.module.less'
import { getSessionMerchantInfo } from '@merchant-backend/util'

export default class extends Component {
  render() {
    const { host } = window.location
    const { id } = getSessionMerchantInfo()

    return (
      <dd className={style.qtBox}>
        <span>
          <QRCode
            size={129}
            value={
              host == 'test.hunliji.com'
                ? 'http://mtest.hunliji.com/p/wedding/Public/wap/m/merchant.html?id=' +
                  id
                : host == 'www7.hunliji.com'
                  ? 'http://m7.hunliji.com/merchant/detail_' + id
                  : 'https://m.hunliji.com/merchant/detail_' + id
            }
          />
        </span>
        <em>扫码预览</em>
      </dd>
    )
  }
}
